// import React, { useState } from 'react';

import React, { useState, useRef } from 'react';
import {
    Box,
    Typography,
    Avatar,
    TextField,
    IconButton,
    MenuItem,
    Paper,
    Radio,
    InputAdornment,
    Popper,
    ClickAwayListener
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CloseBlackIcon } from '../../../icons';

const TeamsAlls = [
    { id: 1, name: 'Team Graphic', image: '', code: 'PQ', description: 'Description 1' },
    { id: 2, name: 'Team Dev', image: '', code: 'DM', description: 'Description 2' },
    { id: 3, name: 'Team QC', image: '', code: 'SG', description: 'Description 3' },
    { id: 4, name: 'Team Content', image: '', code: 'VE', description: 'Description 4' },
];

const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const TeamSelectDroupDown = ({ selectedTeamsAll, setSelectedTeamsAll }) => {

    const [search, setSearch] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const anchorRef = useRef(null);

    const filteredTeamsAlls = TeamsAlls.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleTeamsAllSelect = (TeamsAll) => {
        setSelectedTeamsAll(TeamsAll);
        setDropdownOpen(false);
    };

    const handleRemove = () => {
        setSelectedTeamsAll(null);
    };

    // Dummy user and TeamsAll details (can be passed via props)
    const user = {
        name: 'Salona Mishra',
        image: '/assets/images/users/user1.png',
    };

    const TeamsAll = {
        name: 'Teams All Quantum',
        image: '',
        description: 'Worked Desk 1',
    };

    return (
        <>
            {/* TeamsAll Dropdown */}
            <Box mb={2}>
                <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                    <div>
                        {/* <Typography fontWeight={500} mb={'6px'} sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36' }}>TeamsAll*</Typography> */}
                        <TextField
                            fullWidth
                            placeholder="Select Teams All"
                            inputRef={anchorRef}
                            value={selectedTeamsAll?.name || ''}
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <ArrowDropDownIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                height: '40px',
                                '& .MuiOutlinedInput-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    border: '1px solid #D0D5DD',
                                    paddingRight: 1,
                                    color: '#64748B',
                                    fontFamily:'Manrope'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none', // removes double border from default outline
                                    fontFamily:'Manrope'
                                },
                            }}
                        />

                        <Popper 
                            open={dropdownOpen}
                            anchorEl={anchorRef.current}
                            style={{ zIndex: 1300, width: anchorRef.current?.offsetWidth ,}}
                        >
                            <Paper sx={{ mt: 1, maxHeight: 250, overflowY: 'auto' }}>
                                <Box p={1} sx={{ position: 'sticky', top: '0', zIndex: '9', background: '#fff', fontFamily:'Manrope' }}>
                                    <TextField
                                        placeholder="Search TeamsAll"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        fullWidth
                                        size="small"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '100px',
                                                fontFamily:'Manrope'
                                            },
                                        }}
                                    />
                                </Box>
                                {filteredTeamsAlls.map((TeamsAll) => (
                                    <MenuItem key={TeamsAll.id} onClick={() => handleTeamsAllSelect(TeamsAll)}>
                                        <Radio checked={selectedTeamsAll?.id === TeamsAll.id} value={TeamsAll.id} />
                                        <Avatar sx={{ width: 32, height: 32, mr: 2, fontSize: '14px', background: '#0067C7', fontFamily:'Manrope' }} src={TeamsAll.image}>
                                            {!TeamsAll.image && getInitials(TeamsAll.name)}
                                        </Avatar>
                                        <Typography>{TeamsAll.name}</Typography>
                                    </MenuItem>
                                ))}
                            </Paper>
                        </Popper>
                    </div>
                </ClickAwayListener>
            </Box>

            {/* Selected TeamsAll display */}
            {selectedTeamsAll && (
                <Box
                    mb={2}
                    p={1}
                    border="1px solid #DFDFDF"
                    borderRadius={100}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        background: '#F6F6F6',
                        height:'50px',
                        fontFamily:'Manrope'
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Avatar src={selectedTeamsAll.image} sx={{ fontSize: '14px', background: '#0067C7', width: '34px', height: '34px', fontFamily:'Manrope' }}>
                            {!selectedTeamsAll.image && getInitials(selectedTeamsAll.name)}
                        </Avatar>
                        <Box>
                            <Typography sx={{ color: '#373737', fontSize: '14px', fontWeight: '600', fontFamily:'Manrope' }}>{selectedTeamsAll.name}</Typography>
                            <Typography sx={{ color: '#9095A1', fontSize: '10px', fontFamily:'Manrope' }}>
                                {selectedTeamsAll.description}
                            </Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={handleRemove}>
                        <CloseBlackIcon />
                    </IconButton>
                </Box>
            )}
        </>
    );
}

export default TeamSelectDroupDown;
